import 'whatwg-fetch'
import qs from 'qs'
import config from '@config'

const { protocol, host } = window.location

const baseUrl = `${protocol}//${host}`
const wpJsonPath = '/wp-json/neuroth/v1'

const createUrl = (path, query = {}) => {
  query.lang = config.get('local.locale')
  return `${baseUrl}${wpJsonPath}${path}${qs.stringify(query, { addQueryPrefix: true })}`
}

export const call = (url, options, onSuccess = () => {}, onError = () => {}) => {
  const controller = new AbortController()
  options.signal = controller.signal

  fetch(url, options)
    .then(async (response) => {
      if (response.ok) {
        const json = await response.json()
        onSuccess(json)
      } else {
        const text = await response.text()
        onError(text)
      }
    })
    .catch((err) => {
      onError(err.message)
    })

  return controller
}

export const callPromise = (url, options) =>
  new Promise((resolve) => {
    call(
      url,
      options,
      (json) => {
        resolve(json)
      },
      (error) => {
        resolve({ success: false, error })
      }
    )
  })

export const getTypes = () => [
  createUrl('/appointments/types/'),
  {
    method: 'GET',
  },
]

export const getType = (id) => [
  createUrl(`/appointments/type/${id}/`),
  {
    method: 'GET',
  },
]

export const getStores = () => [
  createUrl('/appointments/stores/'),
  {
    method: 'GET',
  },
]

export const getStore = (id) => [
  createUrl(`/appointments/stores/${id}`),
  {
    method: 'GET',
  },
]

export const getSlots = (branchCode, templateId, mode) => [
  createUrl('/appointments/slots/', { branchCode, templateId, mode }),
  {
    method: 'GET',
  },
]

export const getForm = () => [
  createUrl('/appointments/form/', { form_id: config.get('local.formId') || 0 }),
  {
    method: 'GET',
  },
]

export const postBooking = (payload) => [
  createUrl('/appointments/book/'),
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  },
]
